<!--
	日期：2025/08/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：底部显示区域
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
-->
<template>
	<div id="footer-container" class="footer-container">
		<div style="margin-bottom: 5px">技术支持 &copyIOE.TOP <span style="padding-left:20px;">创造定义未来 ...</span></div>
		<div style="">
			<div style="color: #888888;gap:20px;display:inline-block;font-size:10px;">
				<a href='https://www.sc96655.com/' target="_blank"><div 
					class="footer-link"><u>&nbsp;&nbsp;中国广电四川网络股份有限公司成都分公司&nbsp;&nbsp;</u></div></a>
				<a href='https://life.app.sccncd.com/gd/z/ps/index/' target="_blank"><div 
					class="footer-link"><u>&nbsp;&nbsp;广电美好生活&nbsp;&nbsp;</u></div></a>
				<div class="footer-link"
					@click='showMessage("敬请关注“广电少儿”视频号！");'><u>&nbsp;&nbsp;广电少儿&nbsp;&nbsp;</u></div>
				<div class="footer-link"  
					@click='showMessage("敬请关注“广爱银龄”视频号！");'><u>&nbsp;&nbsp;广爱银龄&nbsp;&nbsp;</u></div>
			</div>
		</div>
	</div>
</template>
<script>
// 输出元素
export default {
	name: 'footer-container',
	props: ['userInfo'],
	data() {
		return {}
	},
	mounted() {
	},
	components: {
	},
	computed: {
	},
	methods: {
		// 获得认证服务器
		get_auth_BaseUrl()
		{
			return this.$utils.getBaseUrl(true,false,false,2);
		},
		showMessage(msg) {
			this.$message({
				type: 'info',
				message: msg,
			}); 
		},
	}
}
</script>
<style lang="less">
.footer-container {
	padding: 5px 0px;
	align: center;
	align-items: center;
	font-size: 12px;
	color: #666666;
}
.footer-link {
	display: inline-block;
	margin-right: 20px;
	cursor: pointer;
	font-size: 12px;
	color: #777777;
}
</style>